import AircraftsI18nKeys from "./aircrafts/aircrafts.i18n";
import AutocompleteStationsKeys from "./AutocompleteStations/AutocompleteStations.i18n";
import AutocompleteVacationDestinationsKeys from "./AutocompleteVacationDestinations/AutocompleteVacationDestinations.i18n";
import FlightAirlineOperatorI18nKeys from "./FlightAirlineOperator/FlightAirlineOperator.i18n";
import FlightConfirmationCardI18nKeys from "./FlightConfirmationCard/FlightConfirmationCard.i18n";
import FlightCountI18nKeys from "./FlightCount/FlightCount.i18n";
import FlightDurationI18nKeys from "./FlightDuration/FlightDuration.i18n";
import FlightInvalidI18nKeys from "./FlightInvalid/FlightInvalid.i18n";
import FlightNumberI18nKeys from "./FlightNumber/FlightNumber.i18n";
import FlightNumbersI18nKeys from "./FlightNumbers/FlightNumbers.i18n";
import FlightStopsI18nKeys from "./FlightStops/FlightStops.i18n";
import FlightStopsTrackerI18nKeys from "./FlightStopsTracker/FlightStopsTracker.i18n";
import FlightTimeI18nKeys from "./FlightTime/FlightTime.i18n";
import GateI18nKeys from "./Gate/Gate.i18n";
import ImageByStationCodeKeys from "./ImageByStationCode/ImageByStationCode.i18n";
import IndicatorTooltipKeys from "./IndicatorTooltip/IndicatorTooltip.i18n";
import ItineraryRecentSearchI18nKeys from "./ItineraryRecentSearch/ItineraryRecentSearch.i18n";
import NextDayIndicatorKeys from "./NextDayIndicator/NextDayIndicator.i18n";
import OvernightIndicatorKeys from "./OvernightIndicator/OvernightIndicator.i18n";
import PlaneTypeI18nKeys from "./PlaneType/PlaneType.i18n";
import SeatAssignmentI18nKeys from "./SeatAssignment/SeatAssignment.i18n";
import StopDurationI18nKeys from "./StopDuration/StopDuration.i18n";
import TripOriginDestinationBoundDetailKeys from "./TripOriginDestinationBoundDetail/TripOriginDestinationBoundDetail.i18n";

export default {
  ...AircraftsI18nKeys,
  ...AutocompleteStationsKeys,
  ...AutocompleteVacationDestinationsKeys,
  ...FlightAirlineOperatorI18nKeys,
  ...FlightConfirmationCardI18nKeys,
  ...FlightCountI18nKeys,
  ...FlightDurationI18nKeys,
  ...FlightInvalidI18nKeys,
  ...FlightNumberI18nKeys,
  ...FlightNumbersI18nKeys,
  ...FlightStopsI18nKeys,
  ...FlightStopsTrackerI18nKeys,
  ...FlightTimeI18nKeys,
  ...GateI18nKeys,
  ...ImageByStationCodeKeys,
  ...IndicatorTooltipKeys,
  ...ItineraryRecentSearchI18nKeys,
  ...NextDayIndicatorKeys,
  ...OvernightIndicatorKeys,
  ...PlaneTypeI18nKeys,
  ...SeatAssignmentI18nKeys,
  ...StopDurationI18nKeys,
  ...TripOriginDestinationBoundDetailKeys,
};
